import { Input } from "@repo/ui/components/ui/input"
import { Body, Label } from "@repo/ui/components/ui/typography"
import { useTranslateFieldError } from "@repo/ui/lib/i18n"
import { cn } from "@repo/ui/lib/utils"
import * as React from "react"
import { useFieldContext } from "../hooks/form-contexts"

interface NumberFieldProps
  extends Omit<
    React.ComponentProps<typeof Input>,
    "type" | "value" | "onChange" | "name"
  > {
  label?: string
  description?: string
}

export function NumberField({
  label,
  description,
  className,
  ...props
}: NumberFieldProps) {
  const field = useFieldContext<number>()
  const translateFieldError = useTranslateFieldError()

  return (
    <div className="space-y-2">
      {label && (
        <Label
          size="m"
          weight="medium"
          htmlFor={field.name}
          className="leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          {label}
        </Label>
      )}
      <Input
        id={field.name}
        name={field.name}
        type="number"
        value={field.state.value ?? ""}
        onChange={(e) => {
          const value = e.target.value === "" ? 0 : Number(e.target.value)
          field.handleChange(value)
        }}
        onBlur={field.handleBlur}
        className={cn(
          field.state.meta.errors.length > 0 && "border-destructive",
          className,
        )}
        {...props}
      />
      {description && (
        <Body size="m" className="text-muted-foreground">
          {description}
        </Body>
      )}
      {field.state.meta.errors.length > 0 && (
        <Body size="m" weight="medium" className="text-destructive">
          {field.state.meta.errors
            .map((error) => translateFieldError(String(error)))
            .join(", ")}
        </Body>
      )}
    </div>
  )
}
